import React from "react";
import Preferences from "@tvg/pref";

const MicroApp = () => <Preferences />;

export default MicroApp;
